import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

/**
 * Entry point de la aplicación
 * Frontend aislado sin dependencias de tRPC
 * Usa servicios REST directos al proxy backend
 */
createRoot(document.getElementById("root")!).render(<App />);
